export const shouldSkipOffersQuery = true;
